import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from "./LandingPageAppResource";

export const SELF_START_HUB = 'self-start-hub';
export const INTERNAL_LINK = 'internal-link';
export const EXTERNAL_LINK = 'external-link';
export const HOME_OWNERSHIP = 'home-ownership'

class LandingPageActionAppResource extends AppResource {

  get displaySettings() {
    if (typeof this._displaySettings !== 'undefined') {
      return this._displaySettings;
    }
    this._displaySettings = {
      displayTextLabel: null
    }
    if (this.sort === 1) {
      this._displaySettings.displayTextLabel = 'Primary CTA - required'
    }
    if (this.sort === 2) {
      this._displaySettings.displayTextLabel = 'Secondary CTA'
    }

    return this._displaySettings;
  }

  set displaySettings(value) {
    this._displaySettings = {
      displayTextLabel: value.hasOwnProperty('displayTextLabel') ? value.displayTextLabel : null,
    };
  }

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-action';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/actions';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'displayText',
      'type',
      'destination',
      'sort',
      'meta',
      'landingPage',
      'active',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage: LandingPageAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    let rules = {
      landingPageUuid: {
        type: 'string',
      },
      displayText: {
        type: 'string',
      },
      type: {
        type: 'string',
        presence: true,
        length: {
          minimum: 1,
          maximum: 255,
        },
      },
      sort: {
        presence: true,
        numericality: true,
      },
      active: {
        type: 'boolean',
      },
    };

    if (this.type !== SELF_START_HUB) {
      rules = {
        ...rules,
        destination: {
          type: 'string',
          length: {
            minimum: 1,
            maximum: 255,
          },
        },
      }
    }

    if(this.active){
      rules.displayText.presence = true;
      rules.displayText.length = {
        minimum: 1,
        maximum: 255,
      };
    }

    return rules;
  }
}

export default LandingPageActionAppResource;
